export const productType = {
  1: '活期挖矿',
  2: '定期宝',
  3: 'Staking',
  4: '活期矿宝',
  5: '算力挖矿',
  6: '基金',
  7: '抵押借贷',
  8: '定期挖矿',
  9: '新币挖矿',
}